import { Carousel, CarouselArrowNavigation, CarouselWrapper } from '$partials/base/carousel';
import React from 'react';
import { SwiperSlide } from 'swiper/react';
import { formatLinkBlockToUrl } from '$utilities/data';
import { Button } from '$partials/ui';
import { SimpleImage } from '$partials/media';
/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ImageCardCarousel}
 */

const ImageCardCarousel = ({
    heading,
    imageCards
}) => {

    const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 0
    };

    return (
        <div className='module-image-card-carousel theme-light-alt bg-main-background'>
            <div className='py-24 sm:py-40 md:py-48'>
                <Carousel swiperConfig={swiperConfig}>
                    <div className='flex flex-col gap-y-24 w-full mx-auto'>
                        {/* Header with title and controls */}
                        <div className='layout-container layout-site-outer-padding w-full flex items-center justify-end gap-16'>
                            {/* Title */}
                            {heading && (
                                <h2 className='type-style-2 text-main-text-primary w-full'>
                                    {heading}
                                </h2>
                            )}
                            {/* Controls */}
                            <div className='hidden sm:flex'>
                                <CarouselArrowNavigation />
                            </div>
                        </div>

                        {/* Carousel */}
                        <div className='overflow-hidden w-full max-w-screen left-1/2 relative -translate-x-1/2'>
                            <div className='layout-container layout-site-outer-padding overflow-visible'>
                                <div className='col-wrapper'>
                                    <CarouselWrapper>
                                        {imageCards?.map((imageCard, index) => (
                                            <SwiperSlide
                                                className='w-10/12 sm:w-5/12 md:w-4/12 flex'
                                                key={imageCard.id || index}>
                                                <Button
                                                    as='a'
                                                    className='w-full col-padding flex flex-col gap-y-12 max-h-[510px] overflow-hidden'
                                                    href={formatLinkBlockToUrl(imageCard?.optionalLink) || '#'}>

                                                    {imageCard?.heading && (
                                                        <h3 className='type-style-3'>
                                                            {imageCard?.heading}
                                                        </h3>
                                                    )}
                                                    <figure className='relative group h-full'>
                                                        <SimpleImage
                                                            className='w-full h-full object-cover'
                                                            {...imageCard?.image?.image} />
                                                        <div className='absolute inset-0 opacity-0 group-hover:opacity-100 before:absolute before:inset-0 before:bg-[rgba(0,0,0,0.4)] before:mix-blend-saturation before:content-[""] after:absolute after:inset-0 after:bg-[rgba(30,37,165,0.5)] after:mix-blend-screen after:content-[""]' />
                                                    </figure>

                                                </Button>
                                                <div className={`shrink-0 w-[1px] h-full bg-main-border ${index === imageCards?.length - 1 ? 'hidden' : ''}`} />
                                            </SwiperSlide>
                                        ))}
                                    </CarouselWrapper>
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ImageCardCarousel;
